import React from 'react';
import { Badge } from './Badge';
interface SectionHeadingProps {
  eyebrow?: string;
  title: React.ReactNode;
  align?: 'left' | 'center';
  className?: string;
  children?: React.ReactNode;
}
export function SectionHeading({
  eyebrow,
  title,
  align = 'center',
  className = '',
  children
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'items-center text-center mx-auto' : 'items-start text-left';
  return <div className={`flex flex-col ${alignment} max-w-3xl ${className}`} data-id="element-15" data-mp="bkvkz0aob30q">
      {eyebrow ? <Badge variant="sky" className="mb-4 uppercase tracking-wide" data-id="element-16" data-mp="gi598cmbt8mz">
          {eyebrow}
        </Badge> : null}
      <h2 className="text-3xl md:text-4xl lg:text-[2.75rem] leading-tight text-[#1A1A2E] font-bold" data-id="element-17" data-mp="1shghzs7niav">
        {title}
      </h2>
      {children ? <div className="mt-4 text-lg text-[#1A1A2E]/70 leading-relaxed" data-id="element-18" data-mp="uipq338okudu">{children}</div> : null}
    </div>;
}